(function () {

  var KLAVIYO_ID = 'QUfT93';

  var INTENT = [
    { value: 'INTENT_TRAVEL',   label: 'A trip that\'s coming up' },
    { value: 'INTENT_EVENT',    label: 'A special event' },
    { value: 'INTENT_WORK',     label: 'Work or business' },
    { value: 'INTENT_EVERYDAY', label: 'Everyday outfits' },
    { value: 'INTENT_GUIDANCE', label: 'I need help putting looks together' },
  ];

  var OUTCOME = [
    { value: 'OUTCOME_CONFIDENT', label: 'Confident and put together' },
    { value: 'OUTCOME_FEMININE',  label: 'Feminine and beautiful' },
    { value: 'OUTCOME_ELEGANT',   label: 'Elegant and effortless' },
    { value: 'OUTCOME_COMFORT',   label: 'Comfortable but elevated' },
    { value: 'OUTCOME_GUIDANCE',  label: 'I\'m not sure, I need guidance' },
  ];

  var TRAVEL = [
    { value: 'cruise',   label: 'Cruise' },
    { value: 'beach',    label: 'Beach vacation' },
    { value: 'europe',   label: 'Europe' },
    { value: 'business', label: 'Business travel' },
    { value: 'other',    label: 'Something else' },
  ];

  var CONTACT_PREF = [
    { value: 'CONTACT_WHATSAPP', label: 'WhatsApp' },
    { value: 'CONTACT_EMAIL',    label: 'Email' },
  ];

  function isLookContext(container) {
    if (container.hasAttribute('data-sfy-standalone')) return true;
    if (document.getElementById('complete-look-block')) return true;
    if (document.querySelector('[data-look-page]')) return true;
    return false;
  }

  function digitsOnly(str) {
    return (str || '').replace(/[^\d]/g, '');
  }

  function calcSegment(intent, outcome) {
    if (intent === 'INTENT_GUIDANCE' || outcome === 'OUTCOME_GUIDANCE') return 'SEGMENT_GUIDANCE';
    return intent.replace('INTENT_', '') + '_' + outcome.replace('OUTCOME_', '');
  }

  function ga4(name, params) {
    try { if (typeof gtag === 'function') gtag('event', name, params || {}); } catch (e) {}
  }

  function viewed() {
    if (sessionStorage.getItem('sfy_viewed')) return;
    sessionStorage.setItem('sfy_viewed', '1');
    ga4('sfy_form_viewed', { page: window.location.href });
  }

  function post(endpoint, body) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + KLAVIYO_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify(body)
    });
  }

  function submit(data) {
    var travelInterest = data.intent === 'INTENT_TRAVEL' || !!data.travel;
    var now = new Date().toISOString();
    var profileProps = {
      styled_for_you_intent: data.intent, styled_for_you_outcome: data.outcome,
      styled_for_you_segment: data.segment, styled_for_you_source: window.location.href,
      styled_for_you_date: now, styled_for_you_completed: true,
      travel_destination: data.travel || null, travel_interest: travelInterest,
      contact_preference: data.contactPreference
    };
    if (travelInterest) profileProps.last_travel_interest_date = now;

    var profileAttributes = { email: data.email, first_name: data.name, properties: profileProps };
    // phone_number se guarda como identificador estandar SOLO si se eligio WhatsApp y hay numero.
    // No se toca ningun objeto de subscriptions: no hay opt-in de SMS ni de WhatsApp marketing implicito.
    if (data.contactPreference === 'CONTACT_WHATSAPP' && data.phone) {
      profileAttributes.phone_number = data.phone;
    }

    var profilePayload = { data: { type: 'profile', attributes: profileAttributes } };
    var eventPayload = { data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Styled For You Completed' } } },
      profile: { data: { type: 'profile', attributes: { email: data.email } } },
      properties: {
        intent: data.intent, outcome: data.outcome, segment: data.segment,
        source: window.location.href, travel: data.travel || null, travel_interest: travelInterest,
        contact_preference: data.contactPreference,
        phone: data.contactPreference === 'CONTACT_WHATSAPP' ? (data.phone || null) : null,
        phone_wa: data.contactPreference === 'CONTACT_WHATSAPP' ? digitsOnly(data.phone) : null
      }
    } } };
    return post('profiles', profilePayload).then(function () { return post('events', eventPayload); });
  }

  function initForm(container) {
    if (!isLookContext(container)) { container.style.display = 'none'; return; }
    var state = { step: 0, intent: null, outcome: null, travel: null, contactPreference: null };
    viewed();

    function render() {
      container.innerHTML = '';
      if (state.step === 0) renderIntro();
      else if (state.step === 1) renderIntent();
      else if (state.step === 2) renderOutcome();
      else if (state.step === 3 && state.intent === 'INTENT_TRAVEL') renderTravel();
      else if (state.contactPreference === null) renderContactPreference();
      else renderContact();
    }

    function makeQ(text) { var p = document.createElement('p'); p.className = 'sfy-question'; p.textContent = text; container.appendChild(p); }
    function makeOpts(items, fn) {
      items.forEach(function (item) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-option'; btn.textContent = item.label;
        btn.addEventListener('click', function () { fn(item.value); }); container.appendChild(btn);
      });
    }

    function renderIntro() {
      var h = document.createElement('p'); h.className = 'sfy-headline'; h.textContent = 'Not sure what to wear?'; container.appendChild(h);
      var p = document.createElement('p'); p.className = 'sfy-intro'; p.textContent = 'Tell us where you\'re going and we\'ll put together a few outfit ideas for you.'; container.appendChild(p);
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-submit'; btn.textContent = 'GET MY OUTFIT IDEAS';
      btn.addEventListener('click', function () { state.step = 1; render(); }); container.appendChild(btn);
    }
    function renderIntent() {
      makeQ("What's bringing you to Carema today?");
      makeOpts(INTENT, function (val) { state.intent = val; state.step = 2; ga4('sfy_form_started'); render(); });
    }
    function renderOutcome() {
      makeQ('How do you want to feel in those outfits?');
      makeOpts(OUTCOME, function (val) { state.outcome = val; state.step = 3; ga4('sfy_step_2_reached', { intent: state.intent }); render(); });
    }
    function renderTravel() {
      makeQ('Tell us a little about your trip'); ga4('sfy_step_3_reached');
      var skip = document.createElement('button'); skip.type = 'button'; skip.className = 'sfy-skip'; skip.textContent = 'Skip this step';
      skip.addEventListener('click', function () { state.step = 4; render(); }); container.appendChild(skip);
      makeOpts(TRAVEL, function (val) { state.travel = val; state.step = 4; render(); });
    }
    function renderContactPreference() {
      ga4('sfy_contact_pref_reached');
      makeQ('How would you like your stylist to reach you?');
      makeOpts(CONTACT_PREF, function (val) { state.contactPreference = val; ga4('sfy_contact_pref_selected', { preference: val }); render(); });
    }
    function renderContact() {
      ga4('sfy_step_4_reached', { outcome: state.outcome });
      makeQ('Where should we send your outfit ideas?');
      var sub = document.createElement('p'); sub.className = 'sfy-subtext'; sub.textContent = "We'll send them over in a few minutes."; container.appendChild(sub);
      var nameInput = document.createElement('input'); nameInput.type = 'text'; nameInput.placeholder = 'Your first name'; nameInput.className = 'sfy-input'; container.appendChild(nameInput);
      var emailInput = document.createElement('input'); emailInput.type = 'email'; emailInput.placeholder = 'Your email'; emailInput.className = 'sfy-input'; emailInput.required = true; container.appendChild(emailInput);

      var phoneInput = null;
      if (state.contactPreference === 'CONTACT_WHATSAPP') {
        var phoneNote = document.createElement('p'); phoneNote.className = 'sfy-subtext'; phoneNote.textContent = "We'll use this only to help with your styling request."; container.appendChild(phoneNote);
        phoneInput = document.createElement('input');
        phoneInput.type = 'tel';
        phoneInput.placeholder = 'Your WhatsApp number (e.g. +1 305 555 1234)';
        phoneInput.className = 'sfy-input';
        phoneInput.required = true;
        container.appendChild(phoneInput);
      }

      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-submit'; btn.textContent = 'Send Me the Outfits';
      btn.addEventListener('click', function () {
        if (!emailInput.validity.valid || !emailInput.value.trim()) { emailInput.reportValidity(); return; }
        if (state.contactPreference === 'CONTACT_WHATSAPP' && (!phoneInput || !phoneInput.value.trim())) { phoneInput.reportValidity(); return; }
        btn.textContent = 'Sending\u2026'; btn.disabled = true;
        var segment = calcSegment(state.intent, state.outcome);
        submit({
          email: emailInput.value.trim(), name: nameInput.value.trim(),
          intent: state.intent, outcome: state.outcome, segment: segment, travel: state.travel,
          contactPreference: state.contactPreference,
          phone: phoneInput ? phoneInput.value.trim() : null
        })
        .then(function () { ga4('sfy_form_completed', { segment: segment, travel: state.travel || 'none', contact_preference: state.contactPreference }); container.innerHTML = '<p class="sfy-success">Perfect. Check your inbox in a few minutes.</p>'; })
        .catch(function () { btn.textContent = 'Send Me the Outfits'; btn.disabled = false; });
      }); container.appendChild(btn);
    }
    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sfy-form]').forEach(function (el) { initForm(el); });
  });

})();
